export const PATH = '/providers';

export const addBaseRoute = (route) => `${PATH}${route}`;
